import { type FC, type ReactNode, type RefObject } from "react";
import { type GridCursorType } from "./Cursor/GridCursor";
import { GRID_SELECTED_DEPTH, type GridItemType } from "./GridEditor";
import { GridOnTopContext } from "./GridOnTop";
import { GridPosition } from "./GridPosition";

interface Props extends GridItemType {
    selected: string | null;
    children: ReactNode;
    onSelect: (id: string, cursor: GridCursorType) => void;
    onTopRef: RefObject<HTMLDivElement | null>;
}

export const GridItem: FC<Props> = ({
    id,
    top,
    left,
    width,
    height,
    children,
    selected,
    onSelect,
    onTopRef,
}) => {
    const isSelected = selected === id;

    return (
        <GridPosition
            id={`grid-item-${id}`}
            className={"flex justify-center items-center" + (isSelected ? "" : " cursor-pointer")}
            top={top}
            left={left}
            width={width}
            height={height}
            style={{
                zIndex: isSelected ? GRID_SELECTED_DEPTH : undefined,
            }}
            onClick={() => {
                onSelect(id, {
                    top,
                    left,
                    width,
                    height,
                });
            }}
        >
            <GridOnTopContext.Provider value={isSelected ? onTopRef : undefined}>
                {children}
            </GridOnTopContext.Provider>
        </GridPosition>
    );
};
